module.exports = __webpack_public_path__ + "media/images/search-icon-18eb4bbaf12ae74d9e1130c62a56e5bd.svg";